module.exports = __webpack_public_path__ + "img/rongYu1.7fcd6042.png";